import React from 'react';

// SVG animation is used so no global CSS keyframes are needed
const Spinner = () => (
    <svg width="20" height="20" viewBox="0 0 50 50" style={{ verticalAlign: 'middle', marginRight: '0.5rem' }} aria-hidden="true">
        <circle cx="25" cy="25" r="20" fill="none" stroke="#e6e6e6" strokeWidth="6" />
        <path d="M25 5 a20 20 0 0 1 20 20" fill="none" stroke="#1779ba" strokeWidth="6" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
        </path>
    </svg>
);

export default Spinner;
